var processInclude = require('base/util');
const cart = require('./cart/cart');
import Reward from 'antavo_custom/rewardItem';
import PromoCode from 'base_global/cart/promoCode';
import Gift from 'base_global/cart/GiftCard';
import notification from 'base_global/components/notification';
import wishlist from 'base_global/components/wishlist';
import quickEditView from 'base_global/product/quickEditView';
import quickViewPdp from 'base_global/product/quickViewPdp';
import sizeGuide from 'base_global/product/sizeGuide';

// eslint-disable-next-line no-undef
$(function () {
    processInclude(require('base_global/myAccount'));
    processInclude(cart);
    processInclude(new PromoCode());
    processInclude(new Gift());
    processInclude(new Reward());
    processInclude(notification);
    processInclude(wishlist);
    processInclude(quickEditView);
    processInclude(quickViewPdp);
    processInclude(sizeGuide);
});
